<template>
  <!-- Current Claims in Homepage -->
  <div class="flex flex-col">
    <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-2">
      <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-2">
        <div
          class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
        >
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Case#/Type
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Member
                </th>
                 <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Member Status
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Legal Matter
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Created
                </th>
                <th
                  scope="col"
                  class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Status
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="(item, i) in data" :key="i">
                <template v-if="i < 10">
                  <td class="px-6 py-4 whitespace-nowrap text-left">
                    <div class="flex items-center">
                      <div class="ml-2">
                        <div class="text-sm font-medium text-gray-900">
                          {{ item?.number }}
                        </div>
                        <div class="text-sm text-gray-500">
                          {{ item?.type }}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-left">
                    <div class="text-sm text-gray-900">
                      {{ item?.member_name }}
                    </div>
                  </td>
                  <td>
                     <span
                    v-if="lowercase(item.member_status) == 'active'"
                    class="
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-green-100
                        text-green-800
                        ml-5
                      "
                  >
                    {{ item.member_status }}
                  </span>
                   <span
                    v-if="lowercase(item.member_status) == 'inactive'"
                    class="
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-yellow-100
                        text-yellow-800
                        ml-5
                      "
                  >
                    {{ item.member_status }}
                  </span>
                   <span
                    v-if="lowercase(item.member_status) == 'terminated'"
                    class="
                    ml-5
                        px-2
                        inline-flex
                        text-xs
                        leading-5
                        font-semibold
                        rounded-full
                        bg-red-100
                        text-red-800
                      "
                  >
                    {{ item.member_status }}
                  </span>
                  </td>
                  <td
                    class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-left"
                  >
                    {{ item?.coverage }}
                  </td>
                  <td
                    class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-left"
                  >
                    {{ setDateFormat(item?.datecreated) }}
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-left">
                    <span
                      v-if="lowercase(item?.status) == 'csr assigned'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                    >
                      {{ item?.status }}
                    </span>
                    <span
                      v-if="lowercase(item?.status) == 'pending csr assignment'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800"
                    >
                      {{ item?.status }}
                    </span>
                    <span
                      v-if="lowercase(item?.status) == 'ticket intake'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-oraange-100 text-orange-800"
                    >
                      {{ item?.status }}
                    </span>
                    <span
                      v-if="lowercase(item?.status) == 'closed'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800"
                    >
                      {{ item?.status }}
                    </span>
                    <span
                      v-if="lowercase(item?.status) == 'recruitment'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-indigo-100 text-indigo-800"
                    >
                      {{ item?.status }}
                    </span>
                    <span
                      v-if="lowercase(item?.status) == 'pending court date'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800"
                    >
                      {{ item?.status }}
                    </span>
                    <span
                      v-if="lowercase(item?.status) == 'pending confirmation'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800"
                    >
                      {{ item?.status }}
                    </span>
                    <span
                      v-if="lowercase(item?.status) == 'pending rate approval'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                    >
                      {{ item?.status }}
                    </span>
                    <span
                      v-if="lowercase(item?.status) == 'pending trial date'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800"
                    >
                      {{ item?.status }}
                    </span>
                    <span
                      v-if="
                        lowercase(item?.status) == 'alternative benefit offered'
                      "
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800"
                    >
                      {{ item?.status }}
                    </span>
                    <span
                      v-if="
                        lowercase(item?.status) == 'pending account payment'
                      "
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                    >
                      {{ item?.status }}
                    </span>
                    <span
                      v-if="lowercase(item?.status) == 'pending co-pay receipt'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-indigo-100 text-indigo-800"
                    >
                      {{ item?.status }}
                    </span>
                    <!-- matter -->
                    <span
                      v-if="lowercase(item?.status) == 'void'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-800"
                    >
                      {{ item?.status }}
                    </span>
                    <span
                      v-if="lowercase(item?.status) == 'pending'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-blue-100 text-blue-800"
                    >
                      {{ item?.status }}
                    </span>
                    <span
                      v-if="lowercase(item?.status) == 'assigned to attorney'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
                    >
                      {{ item?.status }}
                    </span>
                    <span
                      v-if="lowercase(item?.status) == 'authorized'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800"
                    >
                      {{ item?.status }}
                    </span>
                    <span
                      v-if="lowercase(item?.status) == 'mobile/web submission'"
                      class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-purple-100 text-purple-800"
                    >
                      {{ item?.status }}
                    </span>
                  </td>
                </template>
              </tr>
              <tr v-if="data?.length <= 0">
                <td class="text-center p-3" colspan="6">
                  No Records Found
                </td>
              </tr>
              <!-- More people... -->
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Constants from "../../constants.ts"; // importing constant resubale variables.

export default {
  name: "List",
  data() {
    return {
      setDateFormat: Constants.setDateFormat,
    };
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    lowercase: function(string) {
      if (string != null && string != "") {
        return string.toLowerCase();
      }
    },
  },
};
</script>
